/**
 * AnswersTab Component
 * Displays detailed view of all answers
 */
import React from 'react';
import { ResultData, AnswerDetail } from '../../types/results';

interface AnswersTabProps {
  results: ResultData;
}

export const AnswersTab: React.FC<AnswersTabProps> = ({ results }) => {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-base font-bold text-gray-800">Détail réponses</h2>
        <p className="text-sm text-gray-500">Question par question</p>
      </div>
      
      <div className="max-h-96 overflow-y-auto space-y-2">
        {results.answers.map((answer, idx) => (
          <AnswerCard key={idx} answer={answer} index={idx} />
        ))}
      </div>
    </div>
  );
};

// Individual answer card
interface AnswerCardProps {
  answer: AnswerDetail;
  index: number;
}

const AnswerCard: React.FC<AnswerCardProps> = ({ answer, index }) => {
  const isCorrect = answer.is_correct;
  
  return (
    <div 
      className={`p-3 rounded-lg text-sm ${
        isCorrect 
          ? 'bg-green-50 border-l-4 border-green-500' 
          : 'bg-red-50 border-l-4 border-red-500'
      }`}
    >
      <div className="flex justify-between items-center mb-2">
        <span className="font-semibold text-gray-800">Question {index + 1}</span>
        <div className="flex items-center gap-2">
          <span className="text-gray-500">{answer.points_earned} points</span>
          <span 
            className={`px-2 py-0.5 rounded text-xs font-medium ${
              isCorrect 
                ? 'bg-green-200 text-green-800' 
                : 'bg-red-200 text-red-800'
            }`}
          >
            {isCorrect ? 'Correct' : 'Incorrect'}
          </span>
        </div>
      </div>
      
      <div className="grid grid-cols-2 gap-2 text-sm text-gray-600">
        <p>
          <span className="text-gray-400">Réponse:</span>{' '}
          <span className={isCorrect ? 'text-green-600' : 'text-red-600'}>
            {answer.user_answer || '-'}
          </span>
        </p>
        {!isCorrect && (
          <p>
            <span className="text-gray-400">Correcte:</span>{' '}
            <span className="text-green-600">{answer.correct_answer}</span>
          </p>
        )}
        <p>
          <span className="text-gray-400">Temps:</span>{' '}
          {answer.time_taken}s/{answer.time_limit}s
        </p>
        {answer.distraction_time > 0 && (
          <p>
            <span className="text-gray-400">Distraction:</span>{' '}
            {answer.distraction_time}s ({answer.distraction_moves} mouvements)
          </p>
        )}
      </div>
    </div>
  );
};

export default AnswersTab;
